<template>
  <div :class="classes">
      <el-input :suffix-icon="suffixIcon" v-model="crrentValue" :type="type" class="wt-input" :rows="rows" :autosize="autosize"
	:disabled="disabled" :readonly="readonly" :placeholder="placeholder" @change="change" @blur="blur" @focus="focus" :max="max"
    :min="min" :clearable="clearable" :maxlength="maxLength" :minlength="minLength">
    <slot slot="prefix" name="prefix"/>
    <slot slot="suffix" name="suffix"/>
    <slot slot="prepend" name="prepend"/>
    <slot slot="append" name="append"/>
    </el-input>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'wt-input'

export default {
  name: 'wt-input',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    clearable: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    // 多行文本框行数
    rows: {
      type: [Number, String],
      default: 1
    },
    autosize: {
      type: [Boolean, Object, String],
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    suffixIcon: {
      type: String,
      default: ''
    },
    // 输入的最大值
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: 0
    },
    maxLength: {
      type: Number
    },
    minLength: {
      type: Number
    }
  },
  data () {
    return {
      crrentValue: this.value
    }
  },
  watch: {
    value (val) {
      this.crrentValue = val
    },
    crrentValue (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    // 获得焦点
    focus () {
      this.$emit('focus', this.crrentValue)
    },
    // 输入值改变
    change (val) {
      this.$emit('change', this.crrentValue)
    },
    // 失去焦点
    blur () {
      this.$emit('blur', this.crrentValue)
    }
  }
}
</script>

<style lang="less">
.wt-input{
input[type="number"] {
    -moz-appearance: textfield!important;
    &::-webkit-outer-spin-button,&::-webkit-inner-spin-button{

    -webkit-appearance: none;
    }
}
}
</style>
